import * as menuConstants from "../../../constants/menuConstants";
import * as objectTypes from "../../../constants/objectTypes";

import React, { Component } from "react";

import { DataItem } from "../../../types/dataItem";
import { MasterBaseTable } from "./tables/MasterBaseTable";
import { MenuItem } from "../../../types/menu";
import { OptionItem } from "../../../types/optionItem";
import { PrivilegeItem } from "../../../types/privilegeItem";
import { PropsType } from "../../../containers/scenes/master/MasterBaseSceneContainer";
import { ResizingLayoutSceneContainer } from "../ResizingLayoutScene";

type Props = PropsType;

type State = {
    tableBases: MenuItem | DataItem | OptionItem | PrivilegeItem | null;
};

export class MasterBaseScene extends Component<Props, State> {
    state: State = {
        tableBases:
            (this.props.menuScene
                ? this.props.menuScene.items.find((item) => item.key === this.props.baseTableConstant)
                : null) || null
    };

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>): void {
        if (JSON.stringify(this.props.menuScene) !== JSON.stringify(prevProps.menuScene)) {
            this.setState({
                tableBases:
                    (this.props.menuScene
                        ? this.props.menuScene.items.find((item) => item.key === this.props.baseTableConstant)
                        : null) || null
            });
        }
    }

    getBasesTable = (): JSX.Element | null => {
        const { baseTableConstant } = this.props;
        const { tableBases } = this.state;

        if (tableBases) {
            return (
                <MasterBaseTable
                    tableConstant={baseTableConstant}
                    objectType={objectTypes.MASTER_BASE}
                    dataPrivileges={tableBases}
                    loading={this.props.baseLoading}
                    buttonLoading={this.props.baseButtonLoading}
                    allList={this.props.baseList}
                    activeList={this.props.baseActiveList}
                    columnOrder={this.props.baseColumnOrder}
                    columnVisibility={this.props.baseColumnVisibility}
                    columnWidth={this.props.baseColumnWidth}
                    offset={this.props.baseOffset}
                    page={this.props.basePage}
                    rowCount={this.props.baseRowCount}
                    rowCountCustom={this.props.baseRowCountCustom}
                    search={this.props.baseSearch}
                    searchParams={this.props.baseSearchParams}
                    showFilterRow={this.props.baseShowFilterRow}
                    showGlobalSearch={this.props.baseShowGlobalSearch}
                    sortingAsc={this.props.baseSortingAsc}
                    sortingCriterion={this.props.baseSortingCriterion}
                    totalCount={this.props.baseTotalCount}
                    useTmcNames={this.props.optionUseTmcNames || false}
                />
            );
        }

        return null;
    };

    render(): JSX.Element {
        return (
            <ResizingLayoutSceneContainer
                tables={[this.getBasesTable()].filter((item) => item !== null) as Array<JSX.Element>}
                layout={this.props.sceneLayout}
                sceneTableSize={this.props.baseSceneTableSize}
                dataPrivileges={this.state.tableBases}
                sceneConstant={menuConstants.PAGE_MASTER_BASES}
            />
        );
    }
}
